
import { buildSectionSelector, normalizeSectionId } from '@theme/section-renderer';
import { requestIdleCallback, onDocumentReady } from '@theme/utilities';
const hydratedSections = new Set();

/**
 * Hydrate in-place WITHOUT re-rendering Shopify sections
 */
function hydrateSection(sectionId) {
  const normalizedId = normalizeSectionId(sectionId);
  const section = document.getElementById(buildSectionSelector(normalizedId));

  if (!section || section.dataset.hydrated === 'true') return;

  initComponents(section);

  section.dataset.hydrated = 'true';
}

/**
 * Initialize only JS behaviour (NO DOM replacement)
 */
function initComponents(root) {
  // Example pattern: initialize components safely
  root.querySelectorAll('[data-component]').forEach((el) => {
    if (el.__hydrated) return;
    el.__hydrated = true;

    // call your component init logic here if needed
    // e.g. new Component(el)
  });
}

/**
 * Public hydrate entry point (idle-safe, single pass)
 */

export function hydrate(sectionId, url) {
  if (hydratedSections.has(sectionId)) return;
  hydratedSections.add(sectionId);

  onDocumentReady(() => {
    requestIdleCallback(() => hydrateSection(sectionId, url));
  });
}